import { render, staticRenderFns } from "./IndexCateListNew.vue?vue&type=template&id=40dd82e8"
import script from "./IndexCateListNew.vue?vue&type=script&lang=js"
export * from "./IndexCateListNew.vue?vue&type=script&lang=js"
import style0 from "./IndexCateListNew.vue?vue&type=style&index=0&id=40dd82e8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports